module.exports = __webpack_public_path__ + "static/media/skintype_u.5b855be6.svg";